<template>
    <form
        ref="form"
        @submit.prevent="submit"
        :action="formRoute"
        method="POST"
        class="relative h-full"
    >
        <page-header
            :submit-button-text="data ? 'Update' : 'Create'"
            :show-submit-button="true"
            :submit-button-disabled="submitButtonDisabled || !editable"
            submit-button-type="submit"

            :can-delete="canDelete"
            :delete-route="deleteRoute"
            :delete-value="deleteValue"

            :can-create="canCreate"
            :create-route="createRoute"
            :create-value="createValue"

            :index-route="indexRoute"
            :index-value="indexValue"
            :title="title"
            :subtitle="subtitle"

            :show-preview-button="false"

            :errors="errors"
            :is-slide-over="isSlideOver"

            :version-id="versionId"
            :init-version-id="initVersionId"
            :last-updated-by="lastUpdatedBy"
        />

        <input-rich-text
            name="editor_note"
            label="Editor's note"
            v-model="form.editor_note"
            :language="form.language"
            :error="errors.editor_note ? errors.editor_note[0] : null"
            :maxlength="60000"
        />
        <p class="my-1 text-xs text-gray-600 dark:text-gray-300 mb-3">The note is for internal use only and won’t be displayed on the site</p>

        <input-text
            name="name"
            label="* Name"
            v-model="form.name"
            :error="errors.name ? errors.name[0] : null"
            :maxlength="150"
        />

        <div
            class="border bg-white dark:bg-gray-700 rounded-lg w-full p-4 shadow-sm max-w-4xl mt-3"
        >
            <p class="text-gray-700 dark:text-gray-200 mb-4">Main Game Type</p>
            <reference
                create-text="Create new parent and link parent to this page"
                link-text="Link an existing parent"
                v-model="form.parent"
                model-data="Game Type"
                :language="form.language"
                :should-open-new-window="true"
                :order="{
                    'name': 'asc'
                }"
            />
        </div>

        <input-checkbox
            name="is_live_game"
            label="Live Game (yes/no)"
            class="mt-3"
            v-model="form.is_live_game"
            :error="errors.is_live_game ? errors.is_live_game[0] : null"
        />

        <input type="hidden" name="_token" :value="csrf" />
        <input v-if="data" type="hidden" name="_method" value="patch" />
    </form>
</template>

<script>
import crudForm from "../mixins/crudForm";

export default {
    mixins: [crudForm],
    name: "GameTypeForm",
    data() {
        return {
            form: {
                editor_note: this.getFormData("editor_note"),
                name: this.getFormData("name"),
                parent: this.getFormData("parent"),
                parent_id: this.getFormData("parent_id"),
                is_live_game: !!this.getFormData("is_live_game") || false,
            },
        };
    },
    watch: {
        "form.parent": function (newValue) {
            this.form.parent_id = newValue ? newValue.id : null;
        },
    }
};
</script>
